module.exports = __webpack_public_path__ + "static/team-overlay-bg-2f4b0a667e91a677826fb79819bbfe99.svg";